//文字欄位高度自動
class TextareaAutoHeight {
  constructor() {
    this.textarea = $('textarea');
  }
  autoHeight(){
    this.textarea.each((i, e) => {
      let offset = e.offsetHeight - e.clientHeight;
      $(e).on('keyup input', () => {
        $(e).css('height', 'auto').css('height', e.scrollHeight + offset);
      });
    });
  }
}




//輸出
export {TextareaAutoHeight};


// WEBPACK FOOTER //
// ./js_new/textarea_auto_height.js